function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.02891,0,0,3.02891,-47.2982,-27.8811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.666,13.099C18.666,12.112 18.674,11.422 18.784,10.917C18.882,10.469 19.055,10.137 19.327,9.866C19.598,9.594 19.931,9.421 20.378,9.323C20.883,9.213 21.573,9.205 22.56,9.205L25.839,9.205C26.826,9.205 27.517,9.213 28.022,9.323C28.469,9.421 28.802,9.594 29.073,9.866C29.344,10.137 29.518,10.47 29.615,10.917C29.726,11.422 29.733,12.112 29.733,13.099L29.733,19.839C29.733,21.608 29.724,22.845 29.542,23.618C29.364,24.374 29.012,24.787 28.517,24.967C28.023,25.146 27.488,25.054 26.867,24.588C26.232,24.11 25.432,23.166 24.299,21.809L24.2,21.69L24.101,21.809C22.968,23.166 22.168,24.11 21.533,24.588C20.912,25.054 20.377,25.146 19.882,24.967C19.388,24.787 19.036,24.375 18.858,23.618C18.676,22.845 18.666,21.608 18.666,19.839L18.666,13.099ZM19.896,13.099L19.896,19.839C19.896,21.221 19.893,22.258 19.992,22.985C20.024,23.225 20.066,23.425 20.13,23.585C20.173,23.692 20.214,23.779 20.301,23.81C20.389,23.842 20.475,23.802 20.578,23.747C20.729,23.665 20.889,23.538 21.068,23.375C21.61,22.88 22.271,22.082 23.157,21.021L23.728,20.337C23.845,20.197 24.017,20.116 24.2,20.116C24.382,20.116 24.555,20.197 24.672,20.337L25.243,21.021C26.128,22.082 26.79,22.88 27.332,23.375C27.51,23.538 27.671,23.665 27.822,23.747C27.924,23.802 28.01,23.842 28.098,23.81C28.186,23.779 28.226,23.692 28.269,23.585C28.333,23.425 28.375,23.225 28.408,22.985C28.507,22.258 28.504,21.221 28.504,19.839L28.504,13.099C28.504,12.362 28.506,11.808 28.449,11.382C28.411,11.097 28.357,10.888 28.203,10.735C28.05,10.582 27.841,10.528 27.556,10.49C27.13,10.432 26.577,10.435 25.839,10.435L22.56,10.435C21.823,10.435 21.269,10.432 20.843,10.49C20.558,10.528 20.349,10.582 20.196,10.735C20.043,10.888 19.989,11.097 19.951,11.382C19.893,11.808 19.896,12.362 19.896,13.099Z",
    style: {
      fill: "rgb(154,154,154)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkNormal);
export default __webpack_public_path__ + "static/media/bookmark_normal.3724fd0deb10b81f6331c9518b7dd300.svg";
export { ForwardRef as ReactComponent };